import React, { useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import { PopupConfirm, PopupConfirmHandle } from '../../_layout/popups/PopupConfirm';
import { Chat } from '../../../types/chat';
import { confirmCompletion } from '../../../services/chats';

interface Props {
    chat_pk: string
    onComplete: Function
}

export const ConfirmCompletion = ({chat_pk, onComplete}: Props) => {
    const alertRef = useRef<PopupConfirmHandle>(null);

    const {mutate: complete} = useMutation({
        mutationFn: confirmCompletion,
        onSuccess: (data) => {
            onComplete();
        }
    });

    const submit = () => {
        complete(chat_pk);
    }

    return (
        <>
            <PopupConfirm
                header='Завершить оформление'
                submitBtnText='Подтвердить'
                onSubmit={submit}
                ref={alertRef}
            />
            <button
                className='bg-melon-yellow my-0 px-4 py-3 rounded-lg'
                onClick={() => alertRef?.current?.togglePopup()}
            >
                <div className='my-auto'>
                    Завершить оформление
                </div>
            </button>
        </>
    );
};
